//请自行添加语言资源
const search = {
  orderNo:'订单编号',
  customerOrderNo:'采购单号',
  planDeliveryDate:'预计到货日期',
  shiptoName:'送达方名称',
  soldName:'售达方名称',
  totalVolume:'总体积',
  shiptoTel:'送达方电话',
  totalNetWegit:'总净重',
  orderStatus:'订单状态',
  shiptoNo:'送达方编号',
  feedbackStatus:'SAP反馈状态',
  inputDate:'放入时间',
  orderRemark:'备注',
  customerNo:'客户编码',
  signRemark:'签收备注',
  totalQty:'总箱数',
  totalActShipQty:'总抓单箱数',
  signDate:'签收时间',
  signUserNo:'签收用户',
  pickUpFlag:'是否自提',
  expressCode:'快递单号',
  updateDate:'更新时间',
  orderDate:'订单日期',
  updateUserNo:'更新用户',
  shiptoAddr:'送达方地址',
  // shiptoTel:'联系方式',
  sapNo:'SAP单号',
  carrierName:'承运商',
  customerName:'客户名称',
  soldNo:'售达方编号',
  totalNoTaxPrice:'总价格（未税）',
  inputUserNo:'放入用户',
  totalGrossWegit:'总毛重',
  materielNo:'商品编号',
  materielName:'商品名称',
  orderQty:'订单数量',
  actShipQty:'实发数量',
  actNoShipQty:'未发数量',
  signQty:'签收数量',
  signAbnormalReason:'签收异常原因',
  endUserName:'终端客户',
  saleName:'销售',
  dangerousFlag:'危险品',
  netWeight:'单箱重量',
  volume:'单箱体积',
  noTaxPrice:'未税箱价',
  productNo:'产品编号',
  deliveryNo:'交货号',
  totalNet:'总净价',
  totalTax:'总税额',
  totalPrice:'总计(含税)',
  totalPrice2:'订单总计金额(含税)',
  itemStatus:'SAP状态',
  totalNetReal: '实发总净价',
  totalPriceReal: '实发总计(含税)',
  totalTaxReal: '实发总税额',
  totalQtyReal: '实发总数量',
  print: '打印',
  deleteBatch: '确认删除吗？',
  orderClose:"如订单状态长时间未变更为“已取消”请联系CSC，只有订单状态为“已取消”代表取消成功，确认取消吗",
  specialAddressFlag: '是否特殊地址',
  addType: '特殊地址标识',
  msg:{
  },
  fullGoodsFlag:'货齐发货'
};
export default search



// WEBPACK FOOTER //
// ./src/page/order/search/lang/search.zh.js